





























import {Component, Prop, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import DeviceApi from "@/module/device/DeviceApi";
import {DevicePropStatus} from "@/model/Device";
import deviceModule from "@/store/module/DeviceModule";
import _ from 'lodash';
import RefreshButton from "@/component/Button/refresh-button.vue";
import RealtimeRefresh from "@/component/Switch/realtime-refresh.vue";

@Component({
  components: {
    RefreshButton,
    RealtimeRefresh,
  },
})
export default class DevicePropStatusView extends Vue {

  private deviceApi = Container.get(DeviceApi)

  private propStatuses: Array<DevicePropStatus> = []

  @Prop()
  protected colNumber!: number | undefined

  private get _colNumber() {
    return this.colNumber ?? 4
  }

  private lodash = _

  private propStatusClass(index: number) {
    switch (index % this._colNumber) {
      case this._colNumber - 1:
        return "prop-status-last"
      default:
        return "prop-status"
    }
  }

  private getGroupedpropStatuses(_colNumber: number) {
    const groupedArr: Array<Array<DevicePropStatus>> = []
    let arr: Array<DevicePropStatus> = []
    this.propStatuses.forEach((status, index) => {
      if (index % _colNumber == 0) arr = []
      arr.push(status)
      if (index % _colNumber == _colNumber - 1
          || index == this.propStatuses.length - 1
      ) groupedArr.push(arr)
    })
    return groupedArr
  }

  private created() {
    this.getPropStatuses()
  }

  async refresh() {
    await this.getPropStatuses()
  }

  private async getPropStatuses() {
    this.propStatuses =
        await this.deviceApi.propStatuses(deviceModule.active.id)
  }
}
